import React, { useState, useEffect, Fragment } from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col, Container } from "reactstrap";
import { DatePicker, Input, message } from "antd";
import dayjs from "dayjs";
import { onFetchListSid } from "../../Api/AppBackend/ListSid";
// Layout
import AppHeader from "../../Layout/AppHeader/";
import AppSidebar from "../../Layout/AppSidebar/";
import AppFooter from "../../Layout/AppFooter/";

// Theme Options
import ThemeOptions from "../../Layout/ThemeOptions/";
import SidList from "../../../src/Views/Sid/SidList";
import UserBox from "../../../src/Layout/AppHeader/Components/UserBox";
import * as configApi from "../../config/configApi.js";
import { withTranslation } from "react-i18next";
import "./input.css";
function Checking(props) {
  const [fromDate, setFromDate] = useState(
    dayjs().startOf("day")
  );
  const [toDate, setToDate] = useState(
    dayjs().endOf("day")
  );
  const dateFormatList = [
    "DD/MM/YYYY HH:mm",
    "DD/MM/YY HH:mm",
    "DD-MM-YYYY HH:mm",
    "DD-MM-YY HH:mm",
  ];
  const { RangePicker } = DatePicker;
  const [userData, setUserData] = useState([]);
  const [filterSearch, setFilterSearch] = useState("");
  const [showInput, setShowInput] = useState(false);


  const ckTypeUser = () => {
    const typeUser = localStorage.getItem("typeUser");
    return typeUser === "1" || typeUser === "2" || typeUser === "3" || typeUser === "4";
  };

  useEffect(() => {
    setShowInput(ckTypeUser());
  }, [fromDate, toDate]);

  return (
    <Fragment>
      <div
       style={{
        backgroundColor:"#f1f4f6"
      }}
        className="background-img"
        // style={{ backgroundImage: "url('/images/bg_view.jpg')" }}
        id="div-all"
      >
        <div className=" app-container app-theme-white fixed-header fixed-sidebar fixed-footer body-tabs-shadow-btn">
          <AppHeader />
          <div
            style={{
              paddingTop: 57,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                paddingBottom: "5px",
                paddingLeft: "15px",
              }}
            >
              {/* {showInput && (
                <>
                  <div
                    style={{
                      fontSize: "18px",
                      fontWeight: 500,
                    }}
                  >
                    Ngày Tiếp nhận:{" "}
                  </div>
                  <RangePicker
                    format={dateFormatList}
                    size="large"
                    showTime={{ format: "HH:mm" }}
                    allowClear={false}
                    defaultValue={[dayjs(fromDate), dayjs(toDate)]}
                    onChange={handleDateChange}
                  />
                  <div
                    style={{
                      fontSize: "18px",
                      fontWeight: 500,
                    }}
                  >
                    Tìm kiếm:{" "}
                  </div>
                  <Input
                    style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      height: "40px",
                      width: "400px",
                    }}
                    placeholder="Nhập PID, Họ tên, SĐT"
                    onChange={(e) => setFilterSearch(e.target.value)}
                    // onKeyPress={handleSearchChange}
                  />
                </>
              )} */}
            </div>

            <div>
              <div
                style={{
                  backgroundColor: configApi.USE_COLOR,
                  fontSize: "large",
                  padding: 5,
                }}
              >
                <h4
                  className="text-center"
                  style={{ color: "white", fontSize: "1.4em" }}
                >
                  {props.t('TEST RESULT LIST')}
                </h4>
              </div>
              {/* style={{ maxHeight:'600px', overflowY: 'auto' }} */}
              <div >
              {showInput && (
                  <>
                    {localStorage.getItem("typeUser") === "4" ? (
                      <SidList 
                      pid={props.global.userID}
                      />
                    ) : (
                      <SidList
                        fromDate={fromDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")}
                        toDate={toDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")}
                        filterSearch={filterSearch}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
//export default Checking;
const mapStateToProps = (state) => ({
  global: state.global,
});
export default connect(mapStateToProps)(
 withTranslation(["dashboard"]) (Checking));
